import { apiClient, getAuthToken } from '@/shared/data/client';
import { mapCodeFileDto, mapQueryResult } from '@/shared/data/dtoMappers';
import type { CodeFileDto, QueryFilter, QueryResult } from '@flowqa/shared';

type CodeFileQueryRequest = {
  page: number;
  pageSize: number;
  filters?: QueryFilter[];
  sorts?: Array<{ field: string; direction: 'asc' | 'desc' }>;
};

type UpdateCodeFileTagsInput = {
  id: string;
  tags?: string[];
};

export const queryCodeFiles = async (
  input: CodeFileQueryRequest,
  orgId?: string | null,
): Promise<QueryResult<CodeFileDto>> => {
  const result = await apiClient.post<QueryResult<CodeFileDto>>('code-files/query', input, {
    orgId,
  });
  return mapQueryResult(result, mapCodeFileDto);
};

export const getCodeFileById = async (id: string, orgId?: string | null): Promise<CodeFileDto> =>
  mapCodeFileDto(await apiClient.get<CodeFileDto>(`code-files/${id}`, { orgId }));

export const updateCodeFileTags = async (
  input: UpdateCodeFileTagsInput,
  orgId?: string | null,
): Promise<CodeFileDto> => {
  const token = getAuthToken();
  return mapCodeFileDto(
    await apiClient.post<CodeFileDto>(
      `code-files/${input.id}/tags`,
      { tags: input.tags },
      { orgId, token },
    ),
  );
};

export const deleteCodeFile = async (
  input: { id: string },
  orgId?: string | null,
): Promise<{ id: string }> => {
  await apiClient.post<undefined>(`code-files/${input.id}/delete`, undefined, {
    orgId,
    token: getAuthToken(),
  });
  return { id: input.id };
};
